import { render, staticRenderFns } from "./StudentTraining.vue?vue&type=template&id=7fe73a92&scoped=true"
import script from "./StudentTraining.vue?vue&type=script&lang=js"
export * from "./StudentTraining.vue?vue&type=script&lang=js"
import style0 from "./StudentTraining.vue?vue&type=style&index=0&id=7fe73a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe73a92",
  null
  
)

export default component.exports